import React, { useEffect, useState } from "react";
// import img from "../../assets/rocket.png";
import { FaArrowRight, FaCheckCircle, FaChevronDown, FaChevronUp, FaCircle } from "react-icons/fa";
import "./webdevelopment.css";
import { FaCircleCheck, FaCircleDollarToSlot, FaCircleDot, FaCircleHalfStroke, FaCircleQuestion, FaRegCircleDot } from "react-icons/fa6";
import img from "../../assets/services images/seo.jpg";
import img1 from "../../assets/services images/web-features.png";
import img2 from "../../assets/services images/solutions-1-768x768.png"
import AOS from 'aos';
import 'aos/dist/aos.css';

function SEO() {
    const [openIndex, setOpenIndex] = useState(0);

    const features = [
        {
            title: "Keyword Research",
            content: "We identify the most relevant and impactful keywords for your business, ensuring that your content aligns with what your target audience is searching for.",
        },
        {
            title: "On-Page Optimization",
            content: "From meta tags and headers to internal linking and content optimization, we enhance each page on your website to improve its relevance and user experience.",
        },
        {
            title: "Link Building",
            content: "We build high-quality backlinks to increase your website’s authority, credibility, and visibility across search engines.",
        },
        {
            title: "Performance Analysis",
            content: "We continuously monitor and analyze your SEO performance, making data-driven adjustments to keep your strategy aligned with evolving search engine algorithms.",
        },
       
    ];

    const [activeIndex, setActiveIndex] = useState(null);

    const handleClick = (index) => {
        // If already active, close it — otherwise open
        setActiveIndex(activeIndex === index ? null : index);
    };

    const services = [
        {
            title: "Customized Solutions",
            desc: "We tailor our SEO approach to fit your business objectives, industry, and competition, ensuring optimal results.",
        },
        {
            title: "Experienced Team",
            desc: "Our SEO specialists stay updated with the latest industry trends and search engine algorithm changes, so your website stays competitive.",
        },
        {
            title: "Transparent Reporting",
            desc: "We provide regular reports and updates, keeping you informed about your site’s performance, traffic growth, and ranking improvements.",
        },
    ];



    const toggleFeature = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

      useEffect(() => {
    AOS.init({
      duration: 1200, // fade duration for all (ms)
      easing: "ease-in-out", // smooth effect
      once: true,
    });
  }, []);

    return (
        <>

            <section className="service-section1">
                <div className="service-section1-container">
                    {/* Left side - text */}
                    <div className="text-headers" data-aos="fade-down">
                        <div className="title-line">
                            <FaCircleDot style={{ color: "#ffffff", marginRight: "8px" }} />
                            <h4>SEO Service</h4>
                        </div>
                        <div className="breadcrumb-line">
                            <span>
                                <a href="/">Home</a> » <a href="/seo">SEO Service</a>
                            </span>
                        </div>
                    </div>



                </div>
            </section>

            <div className="container">

                <section className="main-services-section-all">
                    <div className="main-services-container">

                        {/* Left side - image */}
                        <div className="main-services-image"  data-aos="fade-left">
                            <img src={img} alt="Web Development" />
                        </div>

                        {/* Right side - text */}
                        <div className="main-services-content"data-aos="fade-right">
                            <h1>SEO Service</h1>

                            <p>
                          Boost your online visibility and drive targeted traffic to your website with REDITE’s professional SEO services. Our goal is to help your business reach the top of search engine results, connecting you with your ideal audience and fostering sustainable growth.
                            </p>

                            <h3>Tailored SEO Strategies for Long-Term Success</h3>


                            <p>
                              At REDITE, we understand that effective SEO requires more than just keywords. Our team of experts combines advanced techniques with a strategic approach to create SEO campaigns tailored to your specific goals. By focusing on every aspect of SEO, we ensure your website not only ranks higher but also attracts quality traffic that converts.
                            </p>
                        </div>

                    </div>
                </section>

                <section className="webdev-section">
                    <div className="webdev-container">
                        {/* Left - Accordion Section */}
                        <div className="webdev-left" data-aos="fade-right">
                            <h3>Our SEO Services</h3>

                            {features.map((feature, index) => (
                                <div
                                    key={index}
                                    className={`accordion-item ${openIndex === index ? "active" : ""}`}
                                    onClick={() => toggleFeature(index)}
                                >
                                    <div className="accordion-title">
                                        <span>
                                            {index + 1}. {feature.title}:
                                        </span>
                                        {openIndex === index ? <FaChevronUp /> : <FaChevronDown />}
                                    </div>

                                    {/* SVG Shape only for active accordion */}
                                    {openIndex === index && (
                                        <svg
                                            version="1.1"
                                            className="svg-shape"
                                            viewBox="0 0 541 64"
                                            height="64"
                                            preserveAspectRatio="none"
                                        >
                                            <polygon
                                                className="path"
                                                points="85,55 81,55 51,55 42.5,64 34,55 0,55 0,0 34.4,0 42.5,9.5 50.6,0 81,0 85,0 541,0 541,55 "
                                            ></polygon>
                                        </svg>
                                    )}

                                    {openIndex === index && (
                                        <div className="accordion-content">
                                            <p>{feature.content}</p>
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>

                        {/* Right - Image */}
                        <div className="webdev-right" data-aos="fade-left">
                            <img src={img1} alt="Web Development Illustration" />
                        </div>
                    </div>
                </section>
                <section className="web-dev-section">
                    <div className="web-dev-container">
                        {/* Left Side Image */}
                        <div className="web-dev-left" data-aos="fade-up">
                            <img src={img2} alt="Web Development" />
                        </div>

                        {/* Right Side Content */}
                        <div className="web-dev-right" data-aos="fade-down">
                            <h4>Why Choose REDITE for SEO?</h4>

                            {services.map((item, index) => (
                                <div
                                    key={index}
                                    className={`web-dev-box ${activeIndex === index ? "active" : ""}`}
                                    onClick={() => handleClick(index)}
                                >
                                    <div className="web-dev-box-header">
                                        <FaCheckCircle className="icon" />
                                        <h5>{item.title}:</h5>
                                    </div>

                                    {activeIndex === index && (
                                        <p className="web-dev-desc">{item.desc}</p>
                                    )}
                                </div>
                            ))}
                        </div>
                    </div>
                </section>

                <section className="all-services-page">
                    <div className="all-services-container" data-aos="fade-left">
                        <h4>Our Process: Designed to Maximize Your Success</h4>
                        <p>
                           Our SEO process begins with an in-depth analysis of your business, audience, and competitive landscape. From there, we develop a comprehensive SEO plan tailored to your goals. As your campaign progresses, we continually monitor and refine our strategies to drive sustained growth.
                        </p>

                        <h4>Ready to Elevate Your Search Rankings?</h4>
                   

                        <p>
                         Gain the competitive edge with REDITE’s expert SEO services.
                            <span>  Contact us today to start your journey to better rankings, increased visibility, and long-term success.</span>Let us help your website reach its full potential!
                        </p>
                    </div>
                </section>

            </div>
        </>
    );
}

export default SEO;
